import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const Empty = ({ content }) => {
  const { t } = useTranslation();
  return (
    <Flex align='center' justify='center' w='100%' h='100%'>
      <Box p='16px'>
        <Flex justify='center' mb='2rem'></Flex>
        <Flex justify='center'>
          {content ? content : <Text color='grey'>{t('common.noData')}</Text>}
        </Flex>
      </Box>
    </Flex>
  );
};

export default Empty;
